// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ce2274b2","455":"265ae582","952":"59a96fa7"}[chunkId] + ".chunk.js";
};